export default __webpack_public_path__ + "static/media/sideImage3.ad89090e.png";